import { forwardRef } from "react";
import { ItemDisplayModalBodyProps } from "../types";
import "../../../style/icons.css";
import { ElementSelector } from "../../Filters/Card/ElementSelector.tsx";
import { TypeSelector } from "../../Filters/Card/TypeSelector.tsx";
import { CategorySelector } from "../../Filters/Card/CategorySelector.tsx";
import { JobSelector } from "../../Filters/Card/JobSelector.tsx";
import { OpusSelector, OpusSelectorOptions } from "../../Filters/Card/OpusSelector.tsx";
import { CostSelector } from "../../Filters/Card/CostSelector.tsx";
import { FlagSelector } from "../../Filters/Card/FlagSelector.tsx";
import { TextSelector } from "../../Filters/Card/TextSelector.tsx";
import { TextSymbolSelector } from "../../Filters/Card/TextSymbolSelector.tsx";
import { PowerSelector } from "../../Filters/Card/PowerSelector.tsx";
import { ArtistSelector } from "../../Filters/Card/ArtistSelector.tsx";
import { RaritySelector } from "../../Filters/Card/RaritySelector.tsx";
import { SortBySelector } from "../../Filters/Card/SortBySelector.tsx.tsx";
import { VariantTypeSelector } from "../../Filters/Card/VariantTypeSelector.tsx";
import { CollectedSelector } from "../../Filters/Card/CollectedSelector.tsx";
import { CardFilterState } from "../../../functions/filter/CardFilterCommands.ts";

export type CardFilterModalBodyOptionalProps = {
    showCollectionFilter?: boolean,
    showVariantTypeFilter?: boolean,
    collection?: Record<string, number>,
    opusSelectorOptions?: OpusSelectorOptions
}

export type CardFilterModalBodyProps = ItemDisplayModalBodyProps<CardFilterState> & CardFilterModalBodyOptionalProps;

const CardFilterModalBody = forwardRef<HTMLDivElement, CardFilterModalBodyProps>(
    (props, ref) => {
        return (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-8">
                <TextSelector
                    name={props.currentFilterState.nameText}
                    onEnterPress={props.onApplyFilters}
                    updateName={(value) => props.updateState((copy) => {
                        copy.nameText = value;
                        if (!!value) {
                            copy.searchText = null;
                        }
                    })}
                    effectText={props.currentFilterState.effectText}
                    updateEffectText={(value) => props.updateState((copy) => {
                        copy.effectText = value;
                        if (!!value) {
                            copy.searchText = null;
                        }
                    })} />

                <ElementSelector
                    values={props.currentFilterState.elementState}
                    update={(values) => props.updateState((copy) => copy.elementState = values)}
                    isAnd={props.currentFilterState.elementIsAnd}
                    updateIsAnd={(value) => props.updateState((copy) => copy.elementIsAnd = value)} />

                <TypeSelector
                    values={props.currentFilterState.cardTypeState}
                    update={(values) => props.updateState((copy) => copy.cardTypeState = values)} />

                <CategorySelector
                    values={props.currentFilterState.categoryState}
                    update={(values) => props.updateState((copy) => copy.categoryState = values)}
                    isAnd={props.currentFilterState.categoryIsAnd}
                    updateIsAnd={(value) => props.updateState((copy) => copy.categoryIsAnd = value)} />

                <JobSelector
                    values={props.currentFilterState.jobState}
                    update={(values) => props.updateState((copy) => copy.jobState = values)}
                    isAnd={props.currentFilterState.jobIsAnd}
                    updateIsAnd={(value) => props.updateState((copy) => copy.jobIsAnd = value)} />

                <OpusSelector
                    values={props.currentFilterState.opusState}
                    update={(values) => props.updateState((copy) => copy.opusState = values)}
                    options={props.opusSelectorOptions} />

                <CostSelector
                    values={props.currentFilterState.costState}
                    update={(values) => props.updateState((copy) => copy.costState = values)} />

                <PowerSelector
                    value={props.currentFilterState.powerState}
                    update={(value) => props.updateState((copy) => copy.powerState = value)}
                    operator={props.currentFilterState.powerComparisonSymbolState}
                    updateOperator={(value) => props.updateState((copy) => copy.powerComparisonSymbolState = value)} />

                <FlagSelector
                    values={props.currentFilterState.flagState}
                    update={(values) => props.updateState((stateCopy) => stateCopy.flagState = values)} />

                <TextSymbolSelector
                    values={props.currentFilterState.abilityTextSymbolState}
                    update={(values) => props.updateState((copy) => copy.abilityTextSymbolState = values)} />

                <RaritySelector
                    values={props.currentFilterState.serialTypeState}
                    update={(values) => props.updateState((copy) => copy.serialTypeState = values)} />

                <ArtistSelector
                    values={props.currentFilterState.artistState}
                    update={(value) => props.updateState((copy) => copy.artistState = value)} />

                {
                    props.showVariantTypeFilter &&
                    <VariantTypeSelector
                        values={props.currentFilterState.variantTypeState}
                        update={(values) => props.updateState((copy) => copy.variantTypeState = values)} />
                }

                <SortBySelector
                    value={props.currentFilterState.sortByState}
                    update={(value) => props.updateState((copy) => copy.sortByState = value)}
                    defaultSortOptions="Opus (Asc) / Number (Asc)" />

                {
                    props.collection &&
                    <CollectedSelector
                        value={props.currentFilterState.collectedState}
                        update={(value) => props.updateState((copy) => copy.collectedState = value)}
                        operator={props.currentFilterState.collectedComparisonSymbolState}
                        updateOperator={(value) => props.updateState((copy) => copy.collectedComparisonSymbolState = value)} />
                }
            </div>
        )
    }
);

export default CardFilterModalBody;